export default __webpack_public_path__ + "f9b4cbcf124dc9a6a4141076ad885191.woff2";